import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { ConfigurationFile } from 'containers/misc'
import { MaterialModal } from 'components/layout'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { Note } from '../../misc'


export default class AssessorGuideModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    award: PropTypes.object
  }

  handleClose = () => {
    this.props.onClose()
  }
  render() {
    const { modalId, award } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title="Assessor guidelines"
        titleKey="moduleTitle.assessor_guidelines"
        onClose={() => this.handleClose}
      >

        <MaterialModal.Content noFooter>
          <ConfigurationFile
            configKey={CONFIGURATION_KEYS.assessorRequirements.id}
            organizationId={get(award, 'organization.id')}
            withAuthCode
            formattedName={
              <FormattedMessage
                id="label.assessor_cond_req"
                defaultMessage="Key conditions and requirements"
              />
            }
          />
          <ConfigurationFile
            configKey={CONFIGURATION_KEYS.assessorHandBook.id}
            organizationId={get(award, 'organization.id')}
            withAuthCode
            formattedName={
              <FormattedMessage
                id="label.assessor_ref_handbook"
                defaultMessage="Reference to award handbook"
              />
            }
          />
          <Note hideNodePrefix>
          <FormattedHTMLMessage
            id="label.custom_assessor_guideline_text"
            defaultMessage="This is a text you can modify."
          />
          </Note>
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
